import 'owl.carousel';
import SimpleParallax from 'simple-parallax-js/vanilla';

jQuery(window).load(function () {

   function updateTabIndices() {
      [].forEach.call(document.querySelectorAll(`.owl-item a`), el => {
         el.tabIndex = el.closest(`.owl-item`).classList.contains("active") ? "" : "-1";
      });
   }

   jQuery('.owl-carousel').each(function () {
      jQuery(this).owlCarousel({
         margin: 30,
         loop: true,
         nav: true,
         navText: ['<div class="arrow"><img src="' + templateDir + '/img/arrow.svg" alt="Edellinen hanke" /></div>', '<div class="arrow"><img src="' + templateDir + '/img/arrow.svg" alt="Seuraava hanke" /></div>'],
         navElement: 'button type="button" role="presentation" aria-label="karuselli navigaatio"',
         dots: true,
         dotsEach: true,
         navSpeed: 1000,
         dotSpeed: 1000,
         responsive: {
            0: {
               items: 1,

            },
            768: {
               items: 2,
            }
         }
      });
      jQuery(this).find('.owl-nav, .owl-dots').wrapAll('<div class="owl-controls"></div>');
      jQuery(this).find('.owl-stage-outer').append('<div class="overlay-gradient left position-absolute"></div><div class="overlay-gradient right position-absolute"></div>');
      jQuery(this).find('.owl-dot').each(function (index) {
         jQuery(this).attr('aria-label', index + 1);
      });

      // Accessibility for the win
      let mo = new MutationObserver(mutations => {
         mutations.forEach(mutation => {
            if (mutation.target.classList.contains("owl-item")) {
               updateTabIndices();
            }
         });
      });
      mo.observe(jQuery(this)[0], {
         attributes: true,
         subtree: true,
      });
      updateTabIndices();
   });

   var hero = document.getElementsByClassName('parallax-hero');
   new SimpleParallax(hero, {
      orientation: 'down',
      scale: 1.3,
      delay: 0
   });

   var image = document.getElementsByClassName('parallax-img');
   new SimpleParallax(image, {
      orientation: 'up',
      scale: 1.2,
      delay: 0
   });

   jQuery('.nav-nappi, .toggle-menu li a').on('click', ev => {
      jQuery('.nav-nappi').toggleClass('active');
      jQuery('.toggle-menu').toggleClass('visible').toggleClass('hidden');
      jQuery('body').toggleClass('no-scroll');
      jQuery('.nav-content').toggleClass('content-hidden').toggleClass('content-visible');
      jQuery('#page-header').toggleClass('nav-open').toggleClass('nav-close');
      if (ev.currentTarget.tagName == "BUTTON") {
         ev.currentTarget.ariaExpanded = ev.currentTarget.ariaExpanded == "false" ? "true" : "false";
      }
   });

   function navWidth() {
      jQuery('.main-nav-buttons').each(function () {
         var mainNavWidth = jQuery(this).outerWidth();
         jQuery('.main-nav-buttons-wrap').css('width', mainNavWidth + 'px');
         jQuery('.main-nav-spacer').css('width', mainNavWidth + 'px');
      });
   }
   navWidth();
   jQuery(window).on("resize", function () {
      navWidth();
   });

   var options = {
      reset: false,
      delay: 500,
      origin: 'bottom',
      distance: '100px'
   }
   var optionLeft = {
      reset: false,
      delay: 500,
      origin: 'left',
      distance: '100px'
   }
   var optionsRight = {
      reset: false,
      delay: 500,
      origin: 'right',
      distance: '100px'
   }
   ScrollReveal().reveal('.reveal', options);
   ScrollReveal().reveal('.reveal-left', optionLeft);
   ScrollReveal().reveal('.reveal-right', optionsRight);
   ScrollReveal().reveal('.reveal-row', {
      delay: 500,
      interval: 200,
      origin: 'bottom',
      distance: '100px'
   });

   var heroHeight = jQuery('.hero-front, .hero-page').outerHeight();
   var headerHeight = jQuery('#page-header').outerHeight();

   jQuery('.bg-graphic-wrap').css('top', heroHeight);
   jQuery('.bg-graphic-wrap').css('height', 'calc(100% - ' + heroHeight + 'px' + ')');
   jQuery('.no-hero').css('height', headerHeight + 'px');
   jQuery('.no-hero').closest('body').addClass('no-hero-body');

   Fancybox.bind("[data-fancybox]", {
      // Your custom options
   });
});
